import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Helpers } from '../../helpers/Helpers';
import { MrzResponse } from '../../models/response/mrz/MrzResponse';
import { RootState } from '../../redux/store';

const TestScreen = () => {
    const auth = useSelector((state: RootState) => state.auth)
    const [isListening, setIsListening] = useState(false);
    const [data, setData] = useState<MrzResponse | undefined>(undefined);

    const startListening = () => {
        const key = "MRZ-" + auth.user.user?.data.id;

        const socket = new WebSocket(Helpers.getWsEndpoint() + '/ws');

        setIsListening(true);
        setData(undefined);

        socket.onopen = () => {
            console.log("WebSocket açıldı.");
            socket.send(key);  // Sunucuya dinlemek istediğin key’i gönder
        };

        socket.onmessage = (event) => {
            const data: MrzResponse = JSON.parse(event.data);
            socket.close();
            console.log("Bağlantı kapatıldı.");
            setIsListening(false);
            setData(data);
        };

        socket.onclose = () => {
            console.log("WebSocket kapatıldı.");
            setIsListening(false);
        };

        socket.onerror = (error) => {
            console.error("WebSocket hatası:", error);
            setIsListening(false);
        };
    }

    return (
        <div style={{ padding: 15 }}>
            {
                !isListening && (
                    <button onClick={startListening}>START LISTENING</button>
                )
            }

            {
                data && (
                    <div style={{ marginTop: 15 }}>
                        {
                            data.face_image && (
                                <img style={{ marginBottom: 15 }} width={100} src={'data:image/jpeg;base64,' + data.face_image} />
                            )
                        }

                        <h5>document_type: {data.document_type}</h5>
                        <h5>name: {data.name}</h5>
                        <h5>surname: {data.surname}</h5>
                        <h5>personal_number: {data.personal_number}</h5>
                        <h5>gender: {data.gender}</h5>
                        <h5>birth_date: {data.birth_date}</h5>
                        <h5>expiry_date: {data.expiry_date}</h5>
                        <h5>document_number: {data.document_number}</h5>
                        <h5>nationality: {data.nationality}</h5>
                        <h5>issuing_state: {data.issuing_state}</h5>
                        <h5>name_of_holder: {data.name_of_holder}</h5>
                        <h5>other_names: {data.other_names}</h5>
                    </div>
                )
            }
        </div>
    )
}

export default TestScreen